import { useQuery } from 'react-query';
import quoterApiInstance from '../../api/quoterApiInstance';
import { QUERY_KEYS, DASHBOARD_QUERY_CONFIG } from '../../constants/reactQuery';

export const CREATED_WITHIN_OPTIONS = ['lastMonth', 'last3Months', 'last6Months', 'lastYear', 'all'];
export const ORDER_BY_OPTIONS = [
    'createdDate:asc',
    'createdDate:desc',
    'lastUpdatedAt:asc',
    'lastUpdatedAt:desc',
];

const buildParams = ({ search, country, createdWithin, page, limit, orderBy } = {}) => {
    const params = {};
    if (search) params.search = search;
    if (country) params.country = country;
    if (createdWithin) params.createdWithin = createdWithin;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (orderBy) params.orderBy = orderBy;
    return params;
};

const fetchFavoritePlans = async (filters) => {
    const { data } = await quoterApiInstance.get('/my-favorite-plans', {
        params: buildParams(filters),
    });
    // Body shape: { data: [...plans], pagination: {...}, message, status }.
    // Return the whole body so `pagination` survives alongside the list.
    return data;
};

export const useFavoritePlans = (filters = {}, options = {}) => {
    return useQuery(
        QUERY_KEYS.favoritePlans.list(filters),
        () => fetchFavoritePlans(filters),
        {
            ...DASHBOARD_QUERY_CONFIG,
            onError: (error) => {
                console.error('Error fetching favorite plans:', error);
            },
            ...options,
        }
    );
};

export default useFavoritePlans;
